"use client";

import { FlexColumn, FlexColumnAlignJustifyCenter, FlexRowAlignCenter } from "@/components/Flex";
import { ASSETS_URL } from "@/config/deployConstants";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import Image from "next/image";
import br from "@/styles/breakpoints.module.css";

const STATS = [
    {
        stat: "3M +",
        desc: "Student & teacher users",
    },
    {
        stat: "5M +",
        desc: "Study notes created ",
    },
    {
        stat: "10M + ",
        desc: "Flashcards sets created",
    },
];

const feedbacks = [
    {
        image: `${ASSETS_URL}/images/users-profiles/Victoria.png`,
        name: "Victoria Buendia-Serrano",
        college: "College freshman",
        desc: "Knowt’s quiz and spaced repetition features have been a lifesaver. I’m going to Columbia now and studying with Knowt helped me get there! ",
    },
    {
        image: `${ASSETS_URL}/images/users-profiles/Val.png`,
        name: "Val",
        college: "College sophomore",
        desc: "Knowt has been a lifesaver! The learn features in flashcards let me find time and make studying a little more digestible.",
    },
    {
        image: `${ASSETS_URL}/images/users-profiles/Sam-Loos.png`,
        name: "Sam Loos",
        college: "12th grade",
        desc: "I used Knowt to study for my APUSH midterm and it saved my butt! The import from Quizlet feature helped a ton too. Slayed that test with an A!! 😻😻😻",
    },
];

const UserFeedbacksWithStats = () => {
    return (
        <FlexColumnAlignJustifyCenter style={{ width: "100%", gap: spacing.MD, wordBreak: "break-word" }}>
            <FlexRowAlignCenter className={br.mdDownColumn} style={{ gap: spacing.MD, width: "100%" }}>
                {STATS.map(stat => (
                    <FlexColumn
                        key={stat.stat}
                        style={{
                            width: "100%",
                            borderRadius: borderRadius.card,
                            padding: spacing.MD,
                            gap: spacing.XS,
                            backgroundColor: themeColors.neutralWhite,
                        }}>
                        <span
                            style={{
                                fontSize: "44px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "58px",
                            }}
                            data-testid="auto-id-b474aed4-fc03-4c74-ac2d-7e8ae7b9b117">
                            {stat.stat}
                        </span>
                        <span
                            className="secondaryText1"
                            data-testid="auto-id-6278a7ec-db67-4e8b-85ce-caba18af87a1">{stat.desc}</span>
                    </FlexColumn>
                ))}
            </FlexRowAlignCenter>
            <FlexRowAlignCenter
                className={br.mdDownColumn}
                style={{ gap: spacing.MD, width: "100%", alignItems: "stretch" }}>
                {feedbacks.map(feedback => (
                    <FlexColumn
                        key={feedback.name}
                        style={{
                            width: "100%",
                            borderRadius: borderRadius.card,
                            padding: spacing.MD,
                            gap: spacing.SM,
                            backgroundColor: themeColors.neutralWhite,
                        }}>
                        <FlexRowAlignCenter style={{ gap: spacing.SM }}>
                            <Image src={feedback.image} alt={feedback.name} width={68} height={68} />
                            <FlexColumn>
                                <span
                                    className="bodyBold2"
                                    data-testid="auto-id-6851fd29-4425-4cec-bb25-bf6308b0f8e6">{feedback.name}</span>
                                <span
                                    className="secondaryText1"
                                    data-testid="auto-id-ff8d1ddc-16fc-4ebe-96e2-1bbb2b005830">{feedback.college}</span>
                            </FlexColumn>
                        </FlexRowAlignCenter>
                        <span
                            className="secondaryText1"
                            data-testid="auto-id-8a544e24-bceb-4d93-8eaa-b23005a8d3b9">{feedback.desc}</span>
                    </FlexColumn>
                ))}
            </FlexRowAlignCenter>
        </FlexColumnAlignJustifyCenter>
    );
};

export default UserFeedbacksWithStats;
